import styled, { css } from 'styled-components';

interface StyledProps {
  isActive?: boolean;
  error?: boolean;
  isMobile?: boolean;
  disabled?: boolean;
  fixedHeight?: boolean;
}

export const OptionButton = styled.button<StyledProps>`
  flex-direction: row;
  align-items: center;
  background-color: #f4f4f4;
  border: 1px #efefef solid;
  min-height: 36px;
  border-radius: 4px;
  padding: 5px 5px 5px 10px;
  margin: 0 5px;
  flex: 1;
  display: flex;

  ${(props) =>
    props.isMobile &&
    css`
      margin: 5px;
    `}

  ${(props) =>
    props.isActive &&
    css`
      background-color: #2e4383;
    `}
`;

export const OptionButtonText = styled.p<StyledProps>`
  font-size: 15px;
  color: #000;
  flex: 1;
  padding-right: 5px;
  font-weight: bold;
  display: inline-flex;
  text-align: left;

  ${(props) =>
    props.isActive &&
    css`
      color: #ffffff;
    `}
`;

export const QuestionDiv = styled.div<StyledProps>`
  width: ${(props) => (props.isMobile ? 'calc(100% - 30px)' : 'calc(100vw - 250px)')};
  min-width: ${(props) => (props.isMobile ? 'auto' : '750px')};
  margin: 10px 6px;
  margin-left: ${(props) => (props.isMobile ? '0' : '6px')};
  padding-bottom: 10px;
  border: 1px #dddddd solid;
  border-radius: 6px;

  ${(props) =>
    props.isActive &&
    css`
      border-color: #2e4383;
    `}

  ${(props) =>
    props.error &&
    css`
      border-color: #e41e13;
    `}
`;

export const QuestionNavBtn = styled.button<StyledProps>`
  border-radius: 6px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${(props) => (props.isMobile ? '40px' : '48px')};
  height: ${(props) => (props.isMobile ? '40px' : '48px')};
  background-color: #3d3d3d;
  border: none;

  ${(props) =>
    props.isActive &&
    css`
      background-color: #2e4383;
    `}

  ${(props) =>
    props.disabled &&
    css`
      background-color: rgba(61, 61, 61, 0.5);
    `}
`;

export const Flow1Container = styled.div<StyledProps>`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;

  ${(props) =>
    props.fixedHeight &&
    !props.isMobile &&
    css`
      min-height: calc(100vh - 280px);
    `}
`;
